import { faList } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useMemo } from 'react';
import { Col, Row } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

import FilterTab from '../../components/common/FilterTab';
import SearchBox from '../../components/common/SearchBox';
import ToggleViewButton from '../../components/common/ToggleViewbutton';
import FourGrid from '../../components/icons/FourGrid';
import { useAdvanceTableContext } from '../../providers/AdvanceTableProvider';

const OrdersTopSection = ({ activeView }) => {
  const navigate = useNavigate();
  const { setGlobalFilter, getPrePaginationRowModel, getColumn } =
    useAdvanceTableContext();

  const handleFilterItemClick = (columnId, value) => {
    const column = getColumn(columnId);
    column?.setFilterValue(value === 'all' ? '' : value);
  };

  const tabItems = useMemo(() => {
    const rows = getPrePaginationRowModel().rows;

    const countBy = status =>
      rows.filter(
        ({ original }) => String(original.status || '').toLowerCase() === status
      ).length;

    return [
      {
        label: 'All',
        value: 'all',
        onClick: () => handleFilterItemClick('status', 'all'),
        count: rows.length
      },
      {
        label: 'Pending',
        value: 'pending',
        onClick: () => handleFilterItemClick('status', 'pending'),
        count: countBy('pending')
      },
      {
        label: 'In progress',
        value: 'in_progress',
        onClick: () => handleFilterItemClick('status', 'in_progress'),
        count: countBy('in_progress')
      },
      {
        label: 'Critical',
        value: 'critical',
        onClick: () => handleFilterItemClick('status', 'critical'),
        count: countBy('critical')
      },
      {
        label: 'Cancelled',
        value: 'cancelled',
        onClick: () => handleFilterItemClick('status', 'cancelled'),
        count: countBy('cancelled')
      }
    ];
  }, [getPrePaginationRowModel, getColumn]);

  const handleSearchInputChange = e => {
    setGlobalFilter(e.target.value || undefined);
  };

  return (
    <Row className="g-3 justify-content-between align-items-center mb-4">
      <Col xs={12} sm="auto">
        {/* FilterTab deja știe să folosească onClick-ul din tabItems */}
        <FilterTab tabItems={tabItems} />
      </Col>

      <Col xs={12} sm="auto">
        <div className="d-flex align-items-center gap-1">
          <SearchBox
            onChange={handleSearchInputChange}
            placeholder="Search"
            style={{ maxWidth: '30rem' }}
            className="me-3"
          />

          <ToggleViewButton
            tooltip="List view"
            active={activeView === 'list'}
            onClick={() => navigate('/apps/sales-management/order-list-view')}
          >
            <FontAwesomeIcon icon={faList} className="fs-10" />
          </ToggleViewButton>

          <ToggleViewButton
            tooltip="Card view"
            active={activeView === 'card'}
            onClick={() => navigate('/apps/sales-management/order-card-view')}
          >
            <FourGrid />
          </ToggleViewButton>
        </div>
      </Col>
    </Row>
  );
};

export default OrdersTopSection;
